import React from 'react';
import FlexWrapper from 'TMComponents/FlexWrapper';
import styled from 'styled-components';
import { arrayOf, bool, shape, string } from 'prop-types';

const List = styled(FlexWrapper)`
    max-width: 1280px;
    ${({ whiteBackground }) =>
        whiteBackground &&
        `
        background-color: #FFFFFF;
    `}
`;

const ImageListImage = styled.img`
    margin: 20px;
    max-width: 100%;
`;

const ImageList = ({ images, whiteBackground }) => (
    <List
        justify="center"
        align="center"
        whiteBackground={whiteBackground}
        wrap>
        {images.map(({ url, alt, ...rest }) => (
            <ImageListImage key={url} src={url} alt={alt} {...rest} />
        ))}
    </List>
);

ImageList.propTypes = {
    images: arrayOf(
        shape({
            url: string,
            alt: string
        })
    ).isRequired,
    whiteBackground: bool
};

export default ImageList;
